import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { englishTranslation, italianTranslation, frenchTranslation } from '@anticatrade/admin';

i18n.use(initReactI18next).init({
	resources: {
		en: {
			translation: { ...englishTranslation },
		},
		it: {
			translation: { ...italianTranslation },
		},
		fr: {
			translation: { ...frenchTranslation },
		},
	},
	fallbackLng: 'en',
	lng: 'en',
	interpolation: {
		escapeValue: false, // not needed for React as it escapes by default.
	},
});

export default i18n;
